import { TicketStatus } from '@/modules/shared/shared/domain/constants/constants';

export function getStateOfTicket(
    statusName: string,
): { name: string; originalStatus: string; color: string } {
    let status: string = statusName;

    const colors: { [status: string]: string } = {
        [TicketStatus.OPENED]: 'pink',
        [TicketStatus.FIXED]: 'amber',
        [TicketStatus.CLOSED]: 'cyan',
    };
    if (statusName === 'Cerrado' || statusName === 'Finalizado') {
        status = TicketStatus.CLOSED;
    } else if (statusName !== TicketStatus.FIXED) {
        status = TicketStatus.OPENED;
    }
    return { name: status, originalStatus: statusName, color: colors[status] };
}

export function getStatusFilter(filter) {
    let idOpenStatus: string = '';
    let idSolveStatus: string = '';
    let idCloseStatus: string = '';
    let status: { open: string; solve: string; close: string } = {
        open: '',
        solve: '',
        close: '',
    };
    let filters: any = [];
    if (filter !== undefined) {
        filters = filter;
        for (let index = 0; index < filters.values.ticketStatuses.length; index++) {
            if (filters.values.ticketStatuses[index].status == TicketStatus.OPENED) {
                if (idOpenStatus == '') {
                    idOpenStatus = '&status=' + filters.values.ticketStatuses[index].id;
                } else {
                    idOpenStatus =
                        idOpenStatus + '&status=' + filters.values.ticketStatuses[index].id;
                }
            } else if (filters.values.ticketStatuses[index].status == TicketStatus.FIXED) {
                if (idSolveStatus == '') {
                    idSolveStatus = '&status=' + filters.values.ticketStatuses[index].id;
                } else {
                    idSolveStatus =
                        idSolveStatus + '&status=' + filters.values.ticketStatuses[index].id;
                }
            } else if (filters.values.ticketStatuses[index].status == TicketStatus.CLOSED) {
                if (idCloseStatus == '') {
                    idCloseStatus = '&status=' + filters.values.ticketStatuses[index].id;
                } else {
                    idCloseStatus =
                        idCloseStatus + '&status=' + filters.values.ticketStatuses[index].id;
                }
            }
        }
        status.open = idOpenStatus;
        status.solve = idSolveStatus;
        status.close = idCloseStatus;
        return status;
    } else {
        return status;
    }
}
